/* tslint:disable */
import { loadStyles } from '@microsoft/load-themed-styles';
loadStyles([{"rawString":".root_84af6ae9{position:relative;display:-webkit-box;display:-ms-flexbox;display:flex;-ms-flex-wrap:nowrap;flex-wrap:nowrap}.item_84af6ae9{-ms-flex-negative:0;flex-shrink:0;display:inherit}\n"}]);
export const root = "root_84af6ae9";
export const item = "item_84af6ae9";